import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\FetchItemDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemDossierByIdController.php
* @route '/api/dossier/{dossier}/item-dossier/{item_dossier}'
*/
const FetchItemDossierByIdController = (args: { dossier: string | number | { id: string | number }, item_dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, item_dossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemDossierByIdController.url(args, options),
    method: 'get',
})

FetchItemDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/item-dossier/{item_dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\FetchItemDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemDossierByIdController.php
* @route '/api/dossier/{dossier}/item-dossier/{item_dossier}'
*/
FetchItemDossierByIdController.url = (args: { dossier: string | number | { id: string | number }, item_dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, item_dossier: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            item_dossier: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        item_dossier: typeof args.item_dossier === 'object'
        ? args.item_dossier.id
        : args.item_dossier,
    }

    return FetchItemDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{item_dossier}', parsedArgs.item_dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\FetchItemDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemDossierByIdController.php
* @route '/api/dossier/{dossier}/item-dossier/{item_dossier}'
*/
FetchItemDossierByIdController.get = (args: { dossier: string | number | { id: string | number }, item_dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, item_dossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\FetchItemDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemDossierByIdController.php
* @route '/api/dossier/{dossier}/item-dossier/{item_dossier}'
*/
FetchItemDossierByIdController.head = (args: { dossier: string | number | { id: string | number }, item_dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, item_dossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchItemDossierByIdController.url(args, options),
    method: 'head',
})

export default FetchItemDossierByIdController